<div class="container" fxLayout="row">
    <div fxFlex="15%" fxHide fxShow.gt-sm>
        &nbsp;
    </div>
    <div>
        <div #contentContainer></div>
    </div>
    <div fxFlex="15%" fxHide fxShow.gt-sm>
        &nbsp;
    </div>
</div>
